import React, { useState, useEffect, Component } from 'react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-quartz.css';
import { AgGridReact } from 'ag-grid-react';
import '../pagination/pagination.css';
import Pagination from '../pagination/pagination';
import LeaseApiService from '../../services/apiService';
import { RiRefreshLine } from 'react-icons/ri';
import { FaFileCircleExclamation } from 'react-icons/fa6';
import { IoAddSharp } from 'react-icons/io5';
import { useNavigate } from 'react-router-dom';
import Select from 'react-select';
import jsPDF from "jspdf";
import "jspdf-autotable";
import { useSelector } from 'react-redux';
import { getRole } from '../../../Redux/selecters';

const SEARCH_DROPDOWN_TYPES =
  'UMSearchPropertyNo,UMSearchCommunityName,UMSearchStatus,UMSearchUnitType,UMSearchBedrooms,UMSearchUnitView,UMSearchLeased,UMSearchBathrooms,UMSearchBalcony,UMSearchStoreRooms,UMSearchFurnishing,UMSearchMaidRoom';

const selectTheme = (theme) => ({
  ...theme,
  borderRadius: 5,
  padding: 9,
});

const selectStyles = {
  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
    color: state.isFocused ? '#000 ' : '#000',
    ':hover': {
      backgroundColor: '#F5F5F5',
      color: '#000 ',
    },
  }),
};

const getSelectValue = (option) => {
  if (!option) return '';
  return option?.value?.value ?? option?.label ?? '';
};

const appendParamIfFilled = (params, key, value) => {
  if (value !== null && value !== undefined && String(value).trim() !== '') {
    params.append(key, value);
  }
};

const SearchSelect = ({ label, value, options, onChange, isDisabled }) => (
  <div className="d-flex align-items-center unit-search-field">
    <label className="form-label pt-2 start mb-0">{label}</label>
    <Select
      className="p-0 w-100"
      theme={selectTheme}
      menuPortalTarget={document.body}
      styles={selectStyles}
      value={value}
      onChange={onChange}
      options={options?.map((item) => ({ value: item, label: item?.text }))}
      isClearable
      isDisabled={isDisabled}
    />
  </div>
);

const SearchVerticalRange = ({ minLabel, maxLabel, minName, maxName, minValue, maxValue, onChange }) => (
  <div className="unit-search-compact-range d-flex flex-column gap-2">
    <div className="d-flex align-items-center gap-1">
      <label className="form-label pt-2 start mb-0 text-nowrap">{minLabel}</label>
      <input type="number" className="p-2 form-control unit-search-range-input" name={minName} value={minValue} onChange={onChange} />
    </div>
    <div className="d-flex align-items-center gap-1">
      <label className="form-label pt-2 start mb-0 text-nowrap">{maxLabel}</label>
      <input type="number" className="p-2 form-control unit-search-range-input" name={maxName} value={maxValue} onChange={onChange} />
    </div>
  </div>
);

const initialFormData = {
  propertyNo: null,
  communityName: null,
  unitNo: null,
  status: null,
  unitType: null,
  bedrooms: null,
  unitView: null,
  leased: null,
  bathrooms: null,
  balcony: null,
  storeRooms: null,
  furnishing: null,
  maidRoom: null,
  psfMin: '',
  psfMax: '',
  budgetMin: '',
  budgetMax: '',
  sizeMin: '',
  sizeMax: '',
};

const UnitListing = () => {
  const apiService = new LeaseApiService();
  const [loading, setLoading] = useState(true);
  const [rowData, setRowData] = useState([]);
  const [pageSize, setPageSize] = useState(20);
  const [pagination, setPagination] = useState();
  const [FilterTab, setFilterTab] = useState(true);
  const [contextMenu, setContextMenu] = useState(null);
  const [exportData, setExportData] = useState([]);
  const [searchDropdowns, setSearchDropdowns] = useState({});
  const [unitNoOptions, setUnitNoOptions] = useState([]);
  let navigate = useNavigate();
  const role = useSelector(getRole);

  const [formData, setFormData] = useState(initialFormData);

  useEffect(() => {
    const handleClickOutside = () => setContextMenu(null);
    window.addEventListener('click', handleClickOutside);
    return () => window.removeEventListener('click', handleClickOutside);
  }, []);

  useEffect(() => {
    const loadSearchDropdowns = async () => {
      try {
        const params = new URLSearchParams();
        params.append('dropdownTypes', SEARCH_DROPDOWN_TYPES);
        const res = await apiService.getApiParamater('GET_UNIT_MULTIDROP', `?${params.toString()}`);
        setSearchDropdowns(res?.data?.dropdowns || {});
      } catch (e) {
        console.error('Error loading search dropdowns:', e);
      }
    };
    loadSearchDropdowns();
    getItems();
  }, []);

  const getItems = async (newPageNo = pagination?.currentPage) => {
    try {
      const params = new URLSearchParams();
      params.append('PageNo', newPageNo || 1);
      params.append('PageSize', pageSize || 20);
      appendParamIfFilled(params, 'PropertyNo', getSelectValue(formData.propertyNo));
      appendParamIfFilled(params, 'CommunityName', getSelectValue(formData.communityName));
      appendParamIfFilled(params, 'UnitNo', getSelectValue(formData.unitNo));
      appendParamIfFilled(params, 'Status', getSelectValue(formData.status));
      appendParamIfFilled(params, 'UnitType', getSelectValue(formData.unitType));
      appendParamIfFilled(params, 'Bedrooms', getSelectValue(formData.bedrooms));
      appendParamIfFilled(params, 'UnitView', getSelectValue(formData.unitView));
      appendParamIfFilled(params, 'Leased', getSelectValue(formData.leased));
      appendParamIfFilled(params, 'Bathrooms', getSelectValue(formData.bathrooms));
      appendParamIfFilled(params, 'Balcony', getSelectValue(formData.balcony));
      appendParamIfFilled(params, 'StoreRooms', getSelectValue(formData.storeRooms));
      appendParamIfFilled(params, 'PsfMin', formData.psfMin);
      appendParamIfFilled(params, 'PsfMax', formData.psfMax);
      appendParamIfFilled(params, 'BudgetMin', formData.budgetMin);
      appendParamIfFilled(params, 'BudgetMax', formData.budgetMax);
      appendParamIfFilled(params, 'SizeMin', formData.sizeMin);
      appendParamIfFilled(params, 'SizeMax', formData.sizeMax);
      appendParamIfFilled(params, 'Furnishing', getSelectValue(formData.furnishing));
      appendParamIfFilled(params, 'MaidRoom', getSelectValue(formData.maidRoom));
      const res = await apiService.getApiParamater('GET_UNIT_LIST', `?${params.toString()}`);
      setLoading(false);
      setRowData(res?.data?.result || []);
      getAllItems(res.data.paginationData)
      setPagination(res.data.paginationData);
    } catch (error) {
      console.error('Error fetching data:', error);
      setLoading(false);
    }
  };

  const getAllItems = async (page) => {
    try {
      const params = new URLSearchParams();
      params.append('PageNo', 1);
      params.append('PageSize', page?.totalRecords || 20);
      appendParamIfFilled(params, 'PropertyNo', getSelectValue(formData.propertyNo));
      appendParamIfFilled(params, 'CommunityName', getSelectValue(formData.communityName));
      appendParamIfFilled(params, 'UnitNo', getSelectValue(formData.unitNo));
      appendParamIfFilled(params, 'Status', getSelectValue(formData.status));
      appendParamIfFilled(params, 'UnitType', getSelectValue(formData.unitType));
      appendParamIfFilled(params, 'Bedrooms', getSelectValue(formData.bedrooms));
      appendParamIfFilled(params, 'UnitView', getSelectValue(formData.unitView));
      appendParamIfFilled(params, 'Leased', getSelectValue(formData.leased));
      appendParamIfFilled(params, 'Bathrooms', getSelectValue(formData.bathrooms));
      appendParamIfFilled(params, 'Balcony', getSelectValue(formData.balcony));
      appendParamIfFilled(params, 'StoreRooms', getSelectValue(formData.storeRooms));
      appendParamIfFilled(params, 'PsfMin', formData.psfMin);
      appendParamIfFilled(params, 'PsfMax', formData.psfMax);
      appendParamIfFilled(params, 'BudgetMin', formData.budgetMin);
      appendParamIfFilled(params, 'BudgetMax', formData.budgetMax);
      appendParamIfFilled(params, 'SizeMin', formData.sizeMin);
      appendParamIfFilled(params, 'SizeMax', formData.sizeMax);
      appendParamIfFilled(params, 'Furnishing', getSelectValue(formData.furnishing));
      appendParamIfFilled(params, 'MaidRoom', getSelectValue(formData.maidRoom));
      const res = await apiService.getApiParamater('GET_UNIT_LIST', `?${params.toString()}`);
      setLoading(false);
      setExportData(res?.data?.result || []);
    } catch (error) {
      console.error('Error fetching data:', error);
      setLoading(false);
    }
  };
  const columnDefs = [
    {
      headerName: '',
      field: 'scheduleId',
      cellRenderer: BtnCellRenderer,
      pinned: 'left',
      cellRendererParams: {
        clicked: function (field, scheduleId) {
          handleMenuAction(field, scheduleId);
        },
      },
      width: 30,
    },
    { headerName: 'Ref no', field: 'ref_No', filter: true, floatingFilter: true, suppressMovable: true, width: 150, pinned: 'left' },
    { headerName: 'Property Name', field: 'property_Name', filter: true, floatingFilter: true, suppressMovable: true, width: 200 },

    { headerName: 'Unit No', field: 'unit_No', filter: true, floatingFilter: true, suppressMovable: true, width: 120 },
    { headerName: 'Unit Type', field: 'unit_Type', filter: true, floatingFilter: true, suppressMovable: true, width: 120 },
    { headerName: 'Unit Category', field: 'unit_Category', filter: true, floatingFilter: true, suppressMovable: true, width: 120 },
    { headerName: 'Unit Class', field: 'unit_Class', filter: true, floatingFilter: true, suppressMovable: true, width: 120 },
    { headerName: 'Owner Name', field: 'seller_Name', filter: true, floatingFilter: true, suppressMovable: true, width: 120 },

    { headerName: 'Status', field: 'status', filter: true, floatingFilter: true, suppressMovable: true, width: 120 },
    { headerName: 'BedRooms', field: 'bedrooms', filter: true, floatingFilter: true, suppressMovable: true, width: 120 },
    {
      headerName: 'Furnished',
      filter: true,
      floatingFilter: true,
      suppressMovable: true,
      width: 120,
      valueGetter: (p) => p.data?.facilities ?? p.data?.Facilities ?? p.data?.furnishing ?? p.data?.Furnishing ?? p.data?.furnished ?? p.data?.Furnished ?? '',
    },
    {
      headerName: 'Community',
      filter: true,
      floatingFilter: true,
      suppressMovable: true,
      width: 160,
      valueGetter: (p) => p.data?.community_Name ?? p.data?.Community_Name ?? p.data?.communityName ?? p.data?.community ?? '',
    },
    {
      headerName: 'Maid Room',
      filter: true,
      floatingFilter: true,
      suppressMovable: true,
      width: 110,
      valueGetter: (p) => p.data?.storeRooms ?? p.data?.store_Rooms ?? p.data?.StoreRooms ?? p.data?.maid_Room ?? '',
    },
    { headerName: 'Total Area', field: 'total_Area', filter: true, floatingFilter: true, suppressMovable: true, width: 120 },
    { headerName: 'Floor', field: 'floor', filter: true, floatingFilter: true, suppressMovable: true, width: 120 },
    { headerName: 'Unit View', field: 'unit_View', filter: true, floatingFilter: true, suppressMovable: true, width: 120 },
    { headerName: 'Rate / Sqft', field: 'sqft_Rate', filter: true, floatingFilter: true, suppressMovable: true, width: 120 },
    {
      headerName: 'Unit Price',
      filter: true,
      floatingFilter: true,
      suppressMovable: true,
      width: 120,
      valueGetter: (p) => p.data?.total_Value ?? p.data?.totalValue ?? p.data?.unit_Price ?? p.data?.unitPrice ?? p.data?.Unit_Price ?? p.data?.UnitPrice ?? '',
    },
    { headerName: 'Rent / Annum', field: 'rent_Per_Annum', filter: true, floatingFilter: true, suppressMovable: true, width: 120 },
    { headerName: 'Property No', field: 'property_No', filter: true, floatingFilter: true, suppressMovable: true, width: 120 },
    { headerName: 'Multi Purpose', field: 'usp', filter: true, floatingFilter: true, suppressMovable: true, width: 120 },
    
  ];

  const handleMenuAction = (action, rowData) => {
    switch (action) {
      case 'edit':
        handleEdit(rowData);
        break;
      case 'view':
        handleView(rowData);
        break;
      default:
        break;
    }
    setContextMenu(null);
  };

  const handleEdit = (rowData) => {
    navigate(`/Customer/Property/Master/Unit/Update`, { state: rowData });
  };

  const handleView = (rowData) => {
    navigate(`/Customer/Property/Master/Unit/view`, { state: rowData });
  };

  const handleClearFilters = () => {
    setFormData(initialFormData);
    setUnitNoOptions([]);
  };

  const handleDropDownChange = async ({ name, value }) => {
    if (name === 'propertyNo') {
      setFormData((prev) => ({ ...prev, propertyNo: value, unitNo: null }));
      setUnitNoOptions([]);
      const propertyValue = getSelectValue(value);
      if (propertyValue) {
        try {
          const params = new URLSearchParams();
          params.append('DropdownFor', 'CustUnitNoByPropertyNo');
          params.append('CascadValue', propertyValue);
          const res = await apiService.getApiParamater('CUSTOMER_CASCAD', `?${params.toString()}`);
          setUnitNoOptions(res?.data?.items || []);
        } catch (e) {
          console.error('Error loading unit numbers:', e);
        }
      }
      return;
    }
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handlenew = () => {
    navigate('/Customer/Property/Master/Unit/Create');
  };
  const exportPDF = () => {
    if (!exportData?.length) {
      alert("No data available to export");
      return;
    }

    const doc = new jsPDF("landscape");

    const primaryColor = [110, 81, 153]; // #6E5199

    // ===== Header =====
    doc.setFillColor(...primaryColor);
    doc.rect(0, 0, 297, 25, "F");

    doc.setTextColor(255, 255, 255);
    doc.setFont("helvetica", "bold");
    doc.setFontSize(20);
    doc.text("UNIT LIST REPORT", 148.5, 15, { align: "center" });

    doc.setFontSize(9);
    doc.text(
      `Generated On: ${new Date().toLocaleDateString()}`,
      280,
      21,
      { align: "right" }
    );

    // Reset text color
    doc.setTextColor(0, 0, 0);

    // ===== Columns =====
    const tableColumn = [
      "Property No",
      "Property Name",
      "Unit No",
      "Ref No",
      "Unit Type",
      "Unit Category",
      "Status",
      "Area",
      "Total Value",
      "Seller Name",
    ];

    // ===== Rows =====
    const tableRows = exportData.map((item) => [
      item.property_No || "-",
      item.property_Name || "-",
      item.unit_No || "-",
      item.ref_No || "-",
      item.unit_Type || "-",
      item.unit_Category || "-",
      item.status || "-",
      Number(item.total_Area || 0).toLocaleString(),
      Number(item.total_Value || 0).toLocaleString(),
      item.seller_Name || "-",
    ]);

    // ===== Table =====
    doc.autoTable({
      startY: 35,
      head: [tableColumn],
      body: tableRows,
      theme: "grid",

      styles: {
        fontSize: 8,
        cellPadding: 3,
        valign: "middle",
        lineColor: [220, 220, 220],
        lineWidth: 0.1,
      },

      headStyles: {
        fillColor: primaryColor,
        textColor: [255, 255, 255],
        fontStyle: "bold",
        halign: "center",
        fontSize: 9,
      },

      alternateRowStyles: {
        fillColor: [248, 246, 252],
      },

      bodyStyles: {
        textColor: [50, 50, 50],
      },

      margin: {
        left: 10,
        right: 10,
      },

      didDrawPage: function (data) {
        const pageCount = doc.internal.getNumberOfPages();

        doc.setFontSize(8);
        doc.setTextColor(120);

        doc.text(
          `Page ${doc.internal.getCurrentPageInfo().pageNumber} of ${pageCount}`,
          data.settings.margin.left,
          doc.internal.pageSize.height - 5
        );

        doc.text(
          "Unit List",
          doc.internal.pageSize.width - 40,
          doc.internal.pageSize.height - 5
        );
      },
    });

    doc.save(`Unit_List.pdf`);
  };
  return (
    <div className="p-3">
      <div className="cost-center-section">
        <div className="d-flex mt-3 cursor-pointer slide-header" onClick={() => setFilterTab(!FilterTab)}>
          <div className="h6 pt-1">Search Parameters</div>
        </div>
        <div className={`slide-content ${FilterTab ? 'open' : 'closed'}`}>
          <div className={`border-box2 p-3 ${FilterTab ? 'slide-in' : 'slide-out'}`}>
            <div className="form-group grid-contain ">
              <SearchSelect
                label="Property"
                value={formData.propertyNo}
                options={searchDropdowns?.UMSearchPropertyNo}
                onChange={(selectedOption) => handleDropDownChange({ name: 'propertyNo', value: selectedOption })}
              />
              <SearchSelect
                label="Unit No"
                value={formData.unitNo}
                options={unitNoOptions}
                isDisabled={!formData.propertyNo}
                onChange={(selectedOption) => handleDropDownChange({ name: 'unitNo', value: selectedOption })}
              />
              <SearchSelect
                label="Unit View"
                value={formData.unitView}
                options={searchDropdowns?.UMSearchUnitView}
                onChange={(selectedOption) => handleDropDownChange({ name: 'unitView', value: selectedOption })}
              />
              <SearchSelect
                label="Status"
                value={formData.status}
                options={searchDropdowns?.UMSearchStatus}
                onChange={(selectedOption) => handleDropDownChange({ name: 'status', value: selectedOption })}
              />
              <SearchSelect
                label="Type"
                value={formData.unitType}
                options={searchDropdowns?.UMSearchUnitType}
                onChange={(selectedOption) => handleDropDownChange({ name: 'unitType', value: selectedOption })}
              />
              <SearchSelect
                label="Bed Room"
                value={formData.bedrooms}
                options={searchDropdowns?.UMSearchBedrooms}
                onChange={(selectedOption) => handleDropDownChange({ name: 'bedrooms', value: selectedOption })}
              />
              <SearchSelect
                label="Bathrooms"
                value={formData.bathrooms}
                options={searchDropdowns?.UMSearchBathrooms}
                onChange={(selectedOption) => handleDropDownChange({ name: 'bathrooms', value: selectedOption })}
              />
              <SearchSelect
                label="Maid Room"
                value={formData.maidRoom}
                options={searchDropdowns?.UMSearchMaidRoom}
                onChange={(selectedOption) => handleDropDownChange({ name: 'maidRoom', value: selectedOption })}
              />
              <SearchSelect
                label="Community"
                value={formData.communityName}
                options={searchDropdowns?.UMSearchCommunityName}
                onChange={(selectedOption) => handleDropDownChange({ name: 'communityName', value: selectedOption })}
              />
              <SearchSelect
                label="Leased"
                value={formData.leased}
                options={searchDropdowns?.UMSearchLeased}
                onChange={(selectedOption) => handleDropDownChange({ name: 'leased', value: selectedOption })}
              />
              <SearchSelect
                label="Balcony"
                value={formData.balcony}
                options={searchDropdowns?.UMSearchBalcony}
                onChange={(selectedOption) => handleDropDownChange({ name: 'balcony', value: selectedOption })}
              />
              <SearchSelect
                label="Store Rooms"
                value={formData.storeRooms}
                options={searchDropdowns?.UMSearchStoreRooms}
                onChange={(selectedOption) => handleDropDownChange({ name: 'storeRooms', value: selectedOption })}
              />
              <SearchSelect
                label="Furnishing"
                value={formData.furnishing}
                options={searchDropdowns?.UMSearchFurnishing}
                onChange={(selectedOption) => handleDropDownChange({ name: 'furnishing', value: selectedOption })}
              />
              <div className="unit-search-last-rows">
                <SearchVerticalRange
                  minLabel="Budget Min"
                  maxLabel="Budget Max"
                  minName="budgetMin"
                  maxName="budgetMax"
                  minValue={formData.budgetMin}
                  maxValue={formData.budgetMax}
                  onChange={handleInputChange}
                />
                <SearchVerticalRange
                  minLabel="Size Min"
                  maxLabel="Size Max"
                  minName="sizeMin"
                  maxName="sizeMax"
                  minValue={formData.sizeMin}
                  maxValue={formData.sizeMax}
                  onChange={handleInputChange}
                />
                <SearchVerticalRange
                  minLabel="PSF Min"
                  maxLabel="PSF Max"
                  minName="psfMin"
                  maxName="psfMax"
                  minValue={formData.psfMin}
                  maxValue={formData.psfMax}
                  onChange={handleInputChange}
                />
              </div>
              <div className="d-flex gap-1" style={{ gridColumn: '1 / -1' }}>
                <div onClick={() => getItems()} className="mainbtnGry flex-end gap-2 w-50">
                  <FaFileCircleExclamation color="#fff" className="center mt-2 mx-2" />
                  <div className="center">Search</div>
                </div>
                <div onClick={() => handleClearFilters()} className="mainbtnRed flex-end gap-2 w-50">
                  <RiRefreshLine color="#fff" className="center mt-2 mx-2" />
                  <div className="center">Reset</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="border-box2 p-3">
        {loading ? (
          <div>Loading...</div>
        ) : (
          <>
            <div className="d-flex justify-contant-between ">
              <h5 className="col mainInvHead">Unit Listing</h5>
              <div className="d-flex justify-content-end gap-1">
                {role === "Admin" || role === "admin" ?
                  < button className="btn btn-primary" onClick={exportPDF}>
                    Export as PDF
                  </button> : ""}
                <div className="col center">
                  <button className="mainbtn " type="submit" onClick={() => handlenew()}>
                    <IoAddSharp color="#fff" className="center mt-1" /> <div>Add</div>
                  </button>
                </div>
              </div>
            </div>
            <div className="gridshad  mt-2">
              <div className="ag-theme-quartz" style={{ height: 650 }}>
                <AgGridReact
                  getRowStyle={(params) => {
                    if (params.node.rowIndex % 2 === 0) {
                      return { background: '#F0EDF5' };
                    } else {
                      return { background: '#fff' };
                    }
                  }}
                  rowData={rowData}
                  enableFilter={true}
                  floatingFilter={true}
                  columnDefs={columnDefs}
                  frameworkComponents={{ BtnCellRenderer }}
                  context={{ setContextMenu }}
                />
              </div>
              <Pagination pageSize={pageSize} setPageSize={setPageSize} pagination={pagination} getItems={getItems} />
            </div>
          </>
        )}
        {contextMenu && (
          <div
            style={{
              position: 'absolute',
              top: contextMenu.mouseY,
              left: contextMenu.mouseX,
              backgroundColor: 'white',
              border: '1px solid gray',
              zIndex: 1000,
              padding: '10px 10px',
              borderRadius: '8px',
              boxShadow: '0px 2px 6px rgba(0,0,0,0.2)',
            }}
          >
            {(() => (
              <div className="d-flex flex-column gap-1">
                <button type="button" className="btn btn-sm btn-primary" onClick={() => handleMenuAction('edit', contextMenu.data)}>
                  Edit
                </button>
                <button type="button" className="btn btn-sm btn-outline-secondary" onClick={() => handleMenuAction('view', contextMenu.data)}>
                  View
                </button>
              </div>
            ))()}
          </div>
        )}
      </div>
    </div >
  );
};
export default UnitListing;
class BtnCellRenderer extends Component {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(e) {
    e.stopPropagation();
    const { context, data } = this.props;

    if (context && context.setContextMenu) {
      context.setContextMenu({
        mouseX: e.clientX,
        mouseY: e.clientY,
        data: data,
      });
    }
  }

  render() {
    return (
      <div className="center pt-1">
        <span onClick={this.handleClick} style={{ cursor: 'pointer', fontSize: '25px' }}>
          &#8942;
        </span>
      </div>
    );
  }
}
